import * as React from 'react';
import * as styles from './ContactStatus.css';
import { Popup } from '@cian/popup-component';

export interface IContactStatusProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

interface IContactStateProps {
  popupShown: boolean;
}

export class ContactStatus extends React.PureComponent<IContactStatusProps, IContactStateProps> {
  public constructor(props: IContactStatusProps) {
    super(props);
    this.state = {
      popupShown: false,
    };
  }

  public render() {
    const { labelText, tooltipText, tooltipTitle } = this.props;
    const { popupShown } = this.state;

    return (
      <div
        className={styles['container']}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div

          className={styles['label']}
        >
          {labelText}
        </div>
        {popupShown && (
          <Popup containerStyle={styles['popup-container']}>
            <div className={styles['popup']}>
              <div className={styles['title']}>{tooltipTitle}</div>
              <div className={styles['text']}>{tooltipText}</div>
            </div>
          </Popup>
        )}
      </div>
    );
  }

  private handleMouseEnter = () => {
    this.setState({ popupShown: true });
  }

  private handleMouseLeave = () => {
    this.setState({ popupShown: false });
  }
}
